import { ProductType } from '@inter-ikea-storageone/range';
import { BehaviorParameters } from 'rangeConfig/@types';

const addHob = ({ coreApi, props }: BehaviorParameters) => {
  const currentHobs = coreApi.entities.getByProductType(ProductType.APPLIANCE_INTEGRATED_HOB);
  coreApi.entities.deleteMultiple(currentHobs);
  coreApi.products.add(props.coreProductId);
};

export default addHob;
